import React from "react";
import Modal from 'react-awesome-modal';
import { observer } from "mobx-react";
import store from '../Stores/SurveyStore'
import { getErrorCommentValue, setTempErrorCommentValue } from '../../helpers'
import { addErrorCommentsCtrl } from "../../control"



const AddExplanationModal = observer(() => {

    const saveAndCloseCommentModal = () => {
        addErrorCommentsCtrl()
        closeModal()
    }

    const closeModal = () => {
        store.showErrorCommentModal = false;
    }
   
    const onChange = e => {
        store.errorCommentContent.TempErrorExplanation = e.target.value;
    };

    const clearComment = e => {
        store.errorCommentContent.TempErrorExplanation = "";
    };

    return (
        <React.Fragment>
            <section className="generalModal">
                    <Modal
                        visible={store.showErrorCommentModal}
                        width="765"
                        effect="fadeInDown"
                        onClickAway={closeModal}>

                        <div className="commentModal">

                            <h3> <i className="fa fa-comment"></i> Add Explanation </h3>
                            <hr />
                            <div className="row">

                                <div className="col-md-12">
                                    <div className="row">

                                        <span className="comment-heading">Current Value: </span> &nbsp; {store.errorCommentContent.CurrentValue} <br />
                                    </div>

                                </div>
                                <div className="col-md-12">
                                    <div className="row">
                                        <span dangerouslySetInnerHTML={{ __html: store.errorCommentContent.WarningFeedback }}></span>
                                        <br />
                                    </div>
                                </div>

                            </div><br />
                            <span className="comment-heading">Please Explain: </span>
                            <textarea type="text" onChange={onChange} value={getErrorCommentValue()}></textarea>
                            {store.errorCommentContent.TempErrorExplanation != "" &&
                                <button type="button" className="btn btn-left-align" onClick={clearComment}>Remove Explanation</button>

                            }

                            <button type="button" className="btn btn-close" onClick={saveAndCloseCommentModal}>Save & Close</button>
                            <button type="button" className="btn btn-close grey" onClick={closeModal}>Cancel</button>
                        </div>



                    </Modal>
            

            </section>
        </React.Fragment>
    );

});

export default AddExplanationModal;